import React from "react";
import { map } from "lodash";
import FileItem from "@/components/controls/FileUpload/FileItem";
import { SavedAttachmentInfo } from "@/entities/attachments/types";

interface Props {
  attachments?: SavedAttachmentInfo[] | null;
}

// Preview mode: loose chips, no frame around them. The design draws a single
// continuous card only for the *form field's* file stack — Large grouped rows
// with a download and remove control each. Putting that card on a preview
// surface is what makes the panel read as a slab.
//
// Chips hug their filename and wrap, same as any other value in this panel —
// they are not stretched to the value column's full width. Stretching was
// tried and read as a form-field-style file stack rather than a stack of
// values.
//
// The scroll cap matches the file stack's. The right gutter keeps our 10px
// scrollbar and its visible track off the chips, and is unconditional so the
// column does not shift when one more attachment tips the list over the cap.
export const ActivityAttachments: React.FC<Props> = ({ attachments }) => (
  <div className="flex flex-row flex-wrap items-start gap-2 max-h-[400px] w-full min-w-0 overflow-y-auto pr-2">
    {map(attachments, (attachment) => (
      <FileItem
        key={attachment.id}
        attachment={attachment}
        size="small"
        isReadOnly
      />
    ))}
  </div>
);
